module.exports = {
  emptyMessage: 'Hei! Anda lupa mengisi nomor kartu Anda.',
  defaultMessage: 'Nomor kartu yang Anda masukkan tidak valid. Pastikan tidak ada kesalahan ketik dan coba lagi.',
};
